import React from "react";
import { DataGrid } from "devextreme-react";
import { Column, HeaderFilter } from "devextreme-react/ui/data-grid";
import ReactDOM from "react-dom";
import NoDataComponent from "../../../../../Shared/noDataImage";
import SiniestroInfoColumn from "../../../../../Shared/SiniestroInfoColumn";

import moment from "moment";

class PeriodosReposo extends React.PureComponent {
  render() {
    return (
      <DataGrid
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        rowAlternationEnabled
        className="custom-table height-min cursor-disabled color"
        noDataText=""
        dataSource={this.props.data}
        onContentReady={(e) => {
          if (this.props.showNoData) {
            const config = {};
            config.addClass = "table-margin-detalle";
            const noDataSpan = e.component.element().querySelector(".dx-scrollable-wrapper");
            ReactDOM.render(<NoDataComponent config={config} message="Sin períodos de reposo" />, noDataSpan);
          }
        }}
      >
        <HeaderFilter visible texts={{ cancel: "Cancelar", emptyValue: "Sin resultados", ok: "Aceptar" }} />
        <Column
          dataField="IsActive"
          caption="Reposo"
          calculateCellValue={(data) => `${data.IsActive ? "Activo" : "No Activo"}`}
          allowFiltering={false}
          cellTemplate={(element, row) => (
            <React.Fragment >
              {
                ReactDOM.render(<SiniestroInfoColumn
                  active={row.data.IsActive}
                  title={`${row.data.IsActive ? "Activo" : "No Activo"}`}
                  subtitle={" "}
                />, element)
              }

            </React.Fragment>
          )}
        />
        <Column
          dataField="FechaInicio"
          caption="Fecha inicio"
          calculateCellValue={(data) => `${data.FechaInicio ? moment(data.FechaInicio).format("DD/MM/YYYY") : "S/D"}`}
        />
        <Column
          dataField="FechaFin"
          caption="Fecha fin"
          sortIndex={0}
          sortOrder="asc"
          sortingMethod={(v1, v2) => {
            const v1d = moment(v1, "DD/MM/YYYY");
            const v2d = moment(v2, "DD/MM/YYYY");
            if (v1d.isAfter(v2d)) return -1;
            if (v1d.isSame(v2d)) return 0;
            if (v1d.isBefore(v2d)) return 1;
            return 0;
          }}
          calculateCellValue={(data) => `${data.FechaFin ? moment(data.FechaFin).format("DD/MM/YYYY") : "S/D"}`}
        />
        <Column dataField="DiasReposo" caption="Días de reposo" allowFiltering={false} />
        <Column
          dataField="TipoAlta"
          caption="Tipo de alta"
          calculateCellValue={(data) => `${data.TipoAlta ? data.TipoAlta : "S/D"}`}
        />
      </DataGrid>
    );
  }
}

export default PeriodosReposo;
